<template>
  <div>
    <form-field-input
        label="Label"
        v-model="form.label"
        :validation-errors="validationErrors.label"
    ></form-field-input>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "TagForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        market_id: this.$store.state.market.market.id,
        label: '',
      },
    }
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone(this.formData) : this.$utils.clone(this.defaultForm);
  },
  computed: {
    activeContact() {
      return (this.$store.state.activeContact && this.$store.state.activeContact.contact)
        ? this.$store.state.activeContact.contact
        : null
    },
  },
  methods: {
    update() {
      return this.$api.tags.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Tag was updated',
            type: 'is-success'
          });

            return res;
          });
    },
    create() {
      if (this.activeContact) {
        this.form.contact_id = this.activeContact.id
      }

      return this.$api.tags.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: res.data,
            type: 'is-success'
          });

            return res;
          });
    },
    delete() {
      return this.$api.tags.delete(this.form.id)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Tag was archived',
            type: 'is-success'
          });

            return res;
          });
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
